import { useActivation } from '@context/MobileOne';
import { FeedbackImage, ScrollToTop } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';

export function SimDataSuccess() {
  const { nextStep, setShowActivationHeader, setStep1SubStep } = useActivation();

  // Const
  const imageContent = useCmsImage('ek_reg_sim-data_suc_web_bg'); // web version doesn't work currently
  // const imageContent = useCmsImage('ek_reg_sim-data_suc_app_bg'); // app version works
  const headerContent = tA11y('ek_reg_sim-data_suc_hdl1');
  const copyTextContent = tA11y('ek_reg_sim-data_suc_txt1');
  const contentImageContent = useCmsImage('ek_reg_sim-data_suc_wwf_content-1');
  const buttonContent = tA11y('ek_sim-data_suc_btn1');

  return (
    <>
      <ScrollToTop>
        <FeedbackImage
          image={imageContent}
          icon={appIconsPath.CELEBRATE}
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          contentImage={contentImageContent}
          buttonText="Weiter zu Ihrem Tarif"
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => {
            nextStep();
            setStep1SubStep(0);
            setShowActivationHeader(true);
          }}
        />
      </ScrollToTop>
    </>
  );
}

export default SimDataSuccess;
